import { createSelector } from 'reselect';

export const tagIdsSelector = (state) => state.bot_tags.ids;
export const tagsByIdSelector = (state) => state.bot_tags.byId;
export const tagsSelector = createSelector(
  tagIdsSelector,
  tagsByIdSelector,
  (tagIds, tagsById) => {
    return tagIds.map((id) => tagsById[id]);
  }
);
export const tagOptionsSelector = createSelector(tagsSelector, (tags) => {
  return tags
    .map((tag) => {
      return {
        tag,
        value: tag.id,
        label: tag.name,
      };
    })
    .sort((a, b) => {
      const labelA = a.label.toLowerCase();
      const labelB = b.label.toLowerCase();
      return labelA < labelB ? -1 : labelA > labelB ? 1 : 0;
    });
});
